import React, { useState, useEffect } from "react";
import { useUser } from "../context/UserContext";
import Select from "react-select";

const SelectBoxResponsavelCadastro = ({ value, onChange }) => {
  const { loadUserOptions } = useUser();
  const [usersLoaded, setUsersLoaded] = useState([]);
  const [responsavelSelecionadoCadastro, setResponsavelSelecionadoCadastro] =
    useState("");

  useEffect(() => {
    loadUserOptions()
      .then(setUsersLoaded)
      .catch((err) => console.error("Erro ao buscar opções de usuários:", err));
  }, []);

  // Transforma a lista de usuários em formato compatível com react-select
  const options = usersLoaded.map((user) => ({
    value: user.id,
    label: user.nome,
  }));

  // Converte o valor atual em objeto para manter o controle visual
  const selectedOption =
    options.find((option) => option.value === value) || null;

  const handleChange = (selected) => {
    const selectedValue = selected ? selected.value : "";
    onChange(selectedValue);
    setResponsavelSelecionadoCadastro(selectedValue);
  };

  return (
    <div style={{ width: "100%", position: "relative" }}>
      <div className="periodo-selecionado">
        <label
          htmlFor="select-box"
          style={{ display: "block", marginBottom: 8 }}
        >
          Selecione um responsável:
        </label>
      </div>
      <Select
        inputId="select-box"
        value={selectedOption}
        onChange={handleChange}
        options={options}
        placeholder="Selecione..."
        isClearable
        menuPortalTarget={document.body}
        menuPosition="fixed"
        menuPlacement="auto"
        styles={{
          control: (base) => ({
            ...base,
            borderColor: "#ccc",
            boxShadow: "none",
            "&:hover": { borderColor: "#007bff" },
            minHeight: "40px",
          }),
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          menu: (base) => ({ ...base, zIndex: 9999 }),
          container: (base) => ({ ...base, zIndex: "auto" }),
        }}
      />
    </div>
  );
};

export default SelectBoxResponsavelCadastro;
